<template>
  <div class="datepickerwrap row card border-0 tw-min-h-[calc(100vh-110px)]">
    <div class="tw-flex tw-gap-5">
      <div v-for="(product, idx) in cardData" :key="idx">
        <div
          class="tw-border-[1px] tw-border-[#D5D5D5] tw-rounded-[5px] tw-mb-4 tw-w-[580px]"
        >
          <img :src="product.image" :alt="product.title" />
          <div class="tw-mx-4 tw-mt-1 tw-border-b-[1px] tw-border-[#D5D5D5] tw-pb-4">
            <h4 class="tw-text-[#1e1e1e] tw-text-[16px] tw-mb-3 tw-font-medium">
              {{ product.title }}
            </h4>
            <p class="tw-text-[#5e5e5e] tw-text-[14px]">
              {{ product.description }}
            </p>
          </div>
          <div class="tw-flex tw-justify-end">
            <button
              class="btn primarycolor tw-m-4"
              @click="handleRedirect(product.title)"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Registration",
  data() {
    return {
      cardData: [
        {
          title: "Ads Reporting",
          description:
            "Share of Voice (SOV) measures a brand's visibility in a market compared to competitors, often in advertising, social media, or PR. A higher SOV indicates stronger market presence and potential brand dominance.",
          image: "/Icons_SVG/MarketPlaces.svg",
        },
        {
          title: "Product Tracking",
          description:
            "Share of Voice (SOV) measures a brand's visibility in a market compared to competitors, often in advertising, social media, or PR. A higher SOV indicates stronger market presence and potential brand dominance.",
          image: "/Icons_SVG/Product_Tracking.svg",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleRedirect(platform) {
      const urlMapper = {
        "Ads Reporting": "#/connect-your-account",
        "Product Tracking": "#/demo-form",
      };
      window.location = urlMapper[platform];
    },
  },
};
</script>
<style scoped>
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
</style>
